import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const PrinceEdwardIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="PEI"
      {...props}
      d="M331,227c0.2,0,0.4,0.1,0.5,0.2l0.5,0.5c0.2,0.2,0.2,0.5,0.1,0.8l-1.2,2.1c-0.1,0.1-0.1,0.3,0,0.5
        c0.3,1,0.7,2-0.4,2.6c-0.4,0.2-0.8,0.3-1.2,0.3c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-1-0.1c-0.3,0-0.7-0.1-1-0.1s-0.5,0-0.8,0.1
        c-0.6,0.1-1.2,0.2-1.9,0.4c-0.2,0-0.4,0.1-0.5,0.1c-0.4,0-0.6-0.1-1.1-0.3c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.4,0
        c-0.3,0-0.6,0.2-0.9,0.2c-0.2,0-0.4-0.1-0.5-0.2l-1-1.2c-0.2-0.1-0.5-0.2-0.7-0.3h-1.3c-0.6,0-1-0.5-0.9-1.1l0.5-2.4
        c0.1-0.5,0.5-0.8,0.9-0.8c0.2,0,0.4,0.1,0.6,0.2l0.9,0.8l0.1,0.1c0.7,0.3,1.4,0.6,2,1c1.1,0.6,1.9,0.8,3.2,0.9c0.1,0,0.2,0,0.2,0
        s0.1,0,0.2,0s0.3-0.1,0.4-0.2c1.4-0.9,2.8-1.8,4.1-2.7l0,0l1.2-0.9C330.7,227,330.9,227,331,227z"
    />
  );
};
